import React, { useState, useEffect } from "react";
// Import dari config/firebase untuk akses database
import { db } from "../../config/firebase"; 
import { ref as dbRef, onValue } from "firebase/database";
// Pastikan RenunganCard, NavBar, Footer, dan RenunganDetailModal di-import dari lokasi yang benar
import {
  NavBar,
  Footer,
  RenunganCard,
  RenunganDetailModal,
} from "../../components";
import "./renungan.scss";

// Komponen Renungan Harian (Tampilan User)
const Renungan = () => {
  // State untuk menyimpan daftar renungan dari Firebase
  const [renunganList, setRenunganList] = useState([]);
  
  // State untuk mengontrol modal: menyimpan data renungan yang dipilih (atau null jika modal tertutup)
  const [dataRenunganDipilih, setDataRenunganDipilih] = useState(null); 

  // 🔄 Ambil semua renungan dari Realtime Database (RTDB)
  useEffect(() => {
    // Merujuk ke node 'renunganHarian' yang diisi dari halaman Operator
    const renunganRef = dbRef(db, "renunganHarian"); 
    
    // onValue akan otomatis mendengarkan perubahan data secara real-time
    const unsubscribe = onValue(renunganRef, (snapshot) => {
      const data = snapshot.val() || {};
      const list = Object.keys(data).map((key) => ({
        id: key,
        ...data[key],
      }));
      
      // Urutkan dari terbaru (terlama timestamp ke terbaru)
      setRenunganList(list.reverse()); 
    }, (error) => {
      console.error("Gagal mengambil data renungan:", error);
      // Anda bisa menambahkan state error di sini jika perlu
    });

    // Clean up listener saat komponen di-unmount
    return () => unsubscribe(); 
  }, []);

  // Fungsi untuk membuka modal saat card diklik
  const handleCardClick = (renungan) => {
    setDataRenunganDipilih(renungan);
  };

  // Fungsi untuk menutup modal
  const handleCloseModal = () => {
    setDataRenunganDipilih(null);
  };

  return (
    <div className="page-container">
      {/* --------------------- MODAL DETAIL RENUNGAN --------------------- */}
      {/* Modal akan muncul hanya jika dataRenunganDipilih bukan null */}
      <RenunganDetailModal
        renungan={dataRenunganDipilih} // Kirim data renungan yang dipilih
        onClose={handleCloseModal} // Kirim fungsi penutup modal
      />
      {/* ----------------------------------------------------------------- */}

      <NavBar />
      <div className="content-wrap">
        <div className="container" style={{ padding: "20px" }}>
          <h1 style={{ 
            textAlign: "center", 
            marginBottom: "30px",
            color: '#4b49ac' // Menggunakan warna primary-dark Anda
          }}>
            Kumpulan Renungan Harian
          </h1>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "25px",
              justifyContent: "center",
              margin: "0 auto",
              maxWidth: "1200px",
            }}
          >
            {/* Menggunakan data dari Firebase: renunganList */}
            {renunganList.length === 0 ? (
                <p style={{textAlign: 'center', gridColumn: '1 / -1'}}>Memuat renungan atau Belum ada renungan yang diunggah.</p>
            ) : (
                renunganList.map((data) => (
                    <div
                        key={data.id}
                        onClick={() => handleCardClick(data)} // <-- Membuka Modal
                        style={{ cursor: "pointer" }}
                    >
                        {/* Props disesuaikan agar cocok dengan struktur data Firebase */}
                        <RenunganCard
                            title={data.judul}
                            penulis={data.penulis}
                            // Kita hanya mengirim content, tidak perlu mengirim onDelete/onEdit (mode operator)
                            content={data.konten} 
                            image={data.gambarUrl}
                        />
                    </div>
                ))
            )}
          </div>
        </div>
      </div>{" "}
      <Footer />
    </div>
  );
};

export default Renungan;